module.exports = __webpack_public_path__ + "fonts/opensans-lightitalic-webfont.0017a987.ttf";